
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface VerificationCodeFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled: boolean;
}

export const VerificationCodeField = ({ 
  value, 
  onChange, 
  isDisabled 
}: VerificationCodeFieldProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="space-y-2">
      <Label htmlFor="verification-code" className="text-sm font-medium flex items-center gap-2">
        <KeyRound className="h-4 w-4 text-primary" />
        {t('verificationCode') || 'Verification Code'}
      </Label>

      <Input
        id="verification-code"
        type="text"
        value={value}
        onChange={onChange}
        placeholder={t('enterVerificationCode') || "Enter 6-digit verification code"}
        maxLength={6}
        className="text-center text-lg tracking-widest"
        disabled={isDisabled}
      />
      
      <p className="text-xs text-muted-foreground mt-1">
        {t('enterVerificationCodeDesc') || 'Enter the 6-digit verification code that was sent to your email address.'}
      </p>
    </div>
  );
};
